import React from "react";
import { useTheme } from "../context/ThemeContext";
import { lightTheme, darkTheme } from "../styles/theme";

function PrivacyPolicy() {
  const { theme } = useTheme();

  const bgColor = theme === "light" ? lightTheme.background : darkTheme.background;
  const textColor = theme === "light" ? lightTheme.text : darkTheme.text;

  return (
    <div
      style={{
        width: "100%",
        minHeight: "100vh",
        backgroundColor: bgColor,
        color: textColor,
        overflow: "auto",
        padding: "40px 20px",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        lineHeight: "1.6",
        fontSize: "16px",
      }}
    >
      <div style={{ maxWidth: "900px", margin: "0 auto" }}>
        <h1 style={{ marginTop: 0, marginBottom: "20px" }}>
          Privacy Policy - nhathuocminhthuy
        </h1>
        <p>
          <strong>Last Updated:</strong> April 5, 2026
        </p>

        <h2 style={{ marginTop: "40px", marginBottom: "15px" }}>
          1. Data Collection
        </h2>
        <div style={{ marginBottom: "20px" }}>
          <p>
            <strong>This extension collects ZERO user data.</strong>
          </p>
          <ul>
            <li>No personal information is collected</li>
            <li>No browsing history is tracked</li>
            <li>No analytics or telemetry data</li>
            <li>No identifiers or cookies for tracking</li>
          </ul>
        </div>

        <h2 style={{ marginTop: "40px", marginBottom: "15px" }}>
          2. Data Transmission
        </h2>
        <div style={{ marginBottom: "20px" }}>
          <p>
            <strong>No data is transmitted to external servers.</strong>
          </p>
          <ul>
            <li>All processing happens locally on your computer</li>
            <li>No cloud services are used</li>
            <li>No third-party services receive data</li>
            <li>No data leaves your browser</li>
          </ul>
        </div>

        <h2 style={{ marginTop: "40px", marginBottom: "15px" }}>
          3. Browser Storage
        </h2>
        <div style={{ marginBottom: "20px" }}>
          <p>
            <strong>We only use local browser storage for configuration.</strong>
          </p>
          <ul>
            <li>Site configurations are stored locally</li>
            <li>User preferences are stored locally</li>
            <li>No personal data is stored</li>
            <li>You can clear stored data anytime via browser settings</li>
          </ul>
        </div>

        <h2 style={{ marginTop: "40px", marginBottom: "15px" }}>
          4. Permissions Explained
        </h2>
        <div style={{ marginBottom: "20px" }}>
          <h3 style={{ marginTop: "20px", marginBottom: "10px" }}>
            🌐 Host Permissions (&lt;all_urls&gt;)
          </h3>
          <p>
            <strong>Why:</strong> To work on any website you visit
          </p>
          <p>
            <strong>How it's used:</strong> Extension only runs on websites
            you've configured
          </p>
          <p>
            <strong>Privacy:</strong> Script injection is local, no tracking
          </p>

          <h3 style={{ marginTop: "20px", marginBottom: "10px" }}>
            ⚙️ Scripting Permission
          </h3>
          <p>
            <strong>Why:</strong> To monitor and validate input fields
          </p>
          <p>
            <strong>How it's used:</strong> Injects local script that watches
            for form inputs
          </p>
          <p>
            <strong>Privacy:</strong> All processing is client-side, nothing
            sent externally
          </p>

          <h3 style={{ marginTop: "20px", marginBottom: "10px" }}>
            💾 Storage Permission
          </h3>
          <p>
            <strong>Why:</strong> To store extension settings and
            configurations
          </p>
          <p>
            <strong>How it's used:</strong> Saves your site configurations
            locally
          </p>
          <p>
            <strong>Privacy:</strong> Only stores configuration data, not
            personal info
          </p>
        </div>

        <div
          style={{
            marginTop: "30px",
            marginBottom: "30px",
            padding: "20px",
            backgroundColor:
              theme === "light"
                ? "rgba(255, 193, 7, 0.1)"
                : "rgba(255, 193, 7, 0.05)",
            borderLeft: "4px solid rgb(255, 193, 7)",
            borderRadius: "4px",
          }}
        >
          <p>
            <strong>⚠️ Important:</strong> This extension does NOT collect,
            store, or transmit any personal user data. All operations are
            performed locally on your machine.
          </p>
        </div>

        <h2 style={{ marginTop: "40px", marginBottom: "15px" }}>
          5. What Data is Stored Locally?
        </h2>
        <div style={{ marginBottom: "20px" }}>
          <p>Only extension configuration:</p>
          <ul>
            <li>List of configured websites (domain names)</li>
            <li>Input field configurations per site</li>
            <li>Feature settings</li>
          </ul>
          <p>
            <strong>NOT stored:</strong> Your personal information, passwords,
            browsing history, or any sensitive data
          </p>
        </div>

        <h2 style={{ marginTop: "40px", marginBottom: "15px" }}>
          6. How to Delete Stored Data
        </h2>
        <div style={{ marginBottom: "20px" }}>
          <p>
            <strong>Clear Extension Storage:</strong>
          </p>
          <ol>
            <li>Open Chrome Settings → Privacy and security → Clear browsing data</li>
            <li>Select "Cookies and other site data"</li>
            <li>Click Clear data</li>
            <li>Or use extension storage clearing tool in Chrome</li>
          </ol>
        </div>

        <h2 style={{ marginTop: "40px", marginBottom: "15px" }}>
          7. Third-Party Services
        </h2>
        <div style={{ marginBottom: "20px" }}>
          <p>
            <strong>This extension does NOT use any third-party services.</strong>
          </p>
          <ul>
            <li>No analytics services</li>
            <li>No tracking pixels</li>
            <li>No external APIs (except what you configure)</li>
            <li>No CDNs</li>
          </ul>
        </div>

        <h2 style={{ marginTop: "40px", marginBottom: "15px" }}>
          8. Changes to This Policy
        </h2>
        <div style={{ marginBottom: "20px" }}>
          <p>
            We may update this policy occasionally. The "Last Updated" date
            above shows when it was last changed. Check back regularly for
            updates.
          </p>
        </div>

        <h2 style={{ marginTop: "40px", marginBottom: "15px" }}>
          9. Contact & Questions
        </h2>
        <div style={{ marginBottom: "20px" }}>
          <p>
            <strong>Email:</strong>{" "}
            <a href="mailto:thuan2172001@gmail.com">
              thuan2172001@gmail.com
            </a>
          </p>
          <p>
            Questions or concerns about privacy? Contact us using the email
            above.
          </p>
        </div>

        <h2 style={{ marginTop: "40px", marginBottom: "15px" }}>
          10. Compliance
        </h2>
        <div style={{ marginBottom: "20px" }}>
          <p>This extension complies with:</p>
          <ul>
            <li>Chrome Web Store policies</li>
            <li>General Data Protection Regulation (GDPR)</li>
            <li>California Consumer Privacy Act (CCPA)</li>
            <li>Chrome Privacy Requirements</li>
          </ul>
        </div>

        <div
          style={{
            marginTop: "30px",
            marginBottom: "40px",
            padding: "20px",
            backgroundColor:
              theme === "light"
                ? "rgba(255, 193, 7, 0.1)"
                : "rgba(255, 193, 7, 0.05)",
            borderLeft: "4px solid rgb(255, 193, 7)",
            borderRadius: "4px",
          }}
        >
          <p>
            <strong>Summary:</strong> nhathuocminhthuy collects ZERO personal
            data. All processing is local. No data is transmitted. Your privacy
            is completely safe.
          </p>
        </div>

        <div
          style={{
            marginTop: "60px",
            paddingTop: "30px",
            borderTop: `1px solid ${
              theme === "light"
                ? "rgba(0, 0, 0, 0.1)"
                : "rgba(255, 255, 255, 0.1)"
            }`,
            textAlign: "center",
            fontSize: "14px",
            opacity: 0.7,
          }}
        >
          <p style={{ margin: 0 }}>
            &copy; 2026 nhathuocminhthuy. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
